<template>
  <transition name="fade">
  <div class="scene">
    <h1>{{ title }}</h1>

    <slot>
      <img v-if="cover" class="cover" :src="cover" />
    </slot>
    
    <div class="middle-control">
      <button class="nextbtn" v-if="showNext" @click="nextScene">
        <svg
           xmlns="http://www.w3.org/2000/svg"
           xmlns:svg="http://www.w3.org/2000/svg"
           version="1.1"
           x="0px"
           y="0px"
           viewBox="0 0 100 125"
           enable-background="new 0 0 100 100"
           xml:space="preserve">
           <path
           d="m 61.823,23.812 v 79.556 l 19.616,6.721 h 5.013 V 17.562 Z m 3.564,44.493 c -0.801,0 -1.449,-1.125 -1.449,-2.512 0,-1.387 0.648,-2.512 1.449,-2.512 0.801,0 1.45,1.125 1.45,2.512 0,1.387 -0.649,2.512 -1.45,2.512 z"
           id="path2"
           inkscape:connector-curvature="0"
           style="fill:#000000" />
           <polygon
           points="31.637,98.003 36.057,98.003 36.057,77.739 31.637,72.462 "
           id="polygon4"
           transform="translate(0,12)"
           style="fill:#000000" />
           <path
           d="m 31.637,12 v 17.658 c 1.293,-0.797 2.804,-1.272 4.419,-1.319 V 16.626 h 53.035 v 93.376 h 4.421 V 12 Z"
           id="path6"
           inkscape:connector-curvature="0"
           style="fill:#000000" />
           <circle
           cx="36.320999"
           cy="37.289001"
           r="7.0180001"
           id="circle8"
           style="fill:#000000" />
           <path
           d="M 55.51,67.492 45.39,63.015 38.952,49.765 c -0.17,-0.454 -0.38,-0.887 -0.628,-1.295 l -0.153,-0.314 c -0.383,-0.786 -0.985,-1.371 -1.655,-1.699 -0.773,-0.586 -1.671,-1.018 -2.669,-1.238 -0.584,-0.128 -1.169,-0.169 -1.745,-0.146 -0.514,-0.016 -1.058,0.061 -1.607,0.256 -0.884,0.25 -1.717,0.672 -2.459,1.241 l -15.113,7.994 c -0.273,0.143 -0.515,0.312 -0.744,0.492 -0.739,0.397 -1.305,1.103 -1.473,1.993 L 8.345,69.562 c -0.295,1.563 0.734,3.072 2.299,3.367 1.565,0.295 3.073,-0.734 3.368,-2.301 l 2.215,-11.736 8.118,-4.295 -3.573,16.216 c -0.108,0.492 -0.149,0.959 -0.136,1.403 L 17.928,89.13 c -0.06,0.081 -0.126,0.151 -0.183,0.238 L 7.094,105.792 c -1.333,2.054 -1.075,4.588 0.574,5.655 1.648,1.068 4.063,0.271 5.396,-1.782 L 23.72,93.242 c 0.336,-0.521 0.571,-1.07 0.708,-1.616 0.125,-0.289 0.23,-0.592 0.282,-0.918 l 2.009,-12.554 c 0.246,0.07 0.493,0.129 0.742,0.183 0.839,0.188 1.573,0.476 2.226,0.772 l 11.118,13.277 3.437,16.389 c 0.438,2.078 2.352,3.439 4.276,3.039 1.921,-0.407 3.128,-2.42 2.691,-4.504 L 47.717,90.67 C 47.58,90.014 47.283,89.441 46.896,88.958 46.765,88.729 46.614,88.507 46.436,88.296 L 34.839,74.453 38.003,60.1 l 2.754,5.667 c 0.082,0.17 0.18,0.326 0.283,0.479 0.187,0.78 0.68,1.452 1.433,1.785 l 10.702,4.735 c 1.339,0.594 2.945,-0.107 3.591,-1.564 0.643,-1.455 0.084,-3.116 -1.256,-3.71 z"
           id="path10"
           inkscape:connector-curvature="0"
           style="fill:#000000" />
        </svg>
        Next
      </button>
    </div>

    <Player :sources="media" :loop="false" :html5="true"
      :trackPostTime="trackPostTime"
      @time="onTimeUpdate"
      @trackdone="onTrackEnd"
      ref="player" />

  </div>
</transition>
</template>

<script>
import Player from '@/components/Player.vue';

export default {
  name: 'Scene',
  components: {
    Player,
  },
  props: {
    id: String,
    title: String,
    media: Array,
    cover: String,
    trackPostTime: Number,
    nextPath: String,
  },
  data () {
    return {
      time: -1, // so a compute is triggered when player loads and sends 0
      // ended: false,
    }
  },
  methods: {
    play() {
      console.log("Scene.play");
      this.$refs.player.play();
    },
    onTimeUpdate(time) {
      // console.log('time', time);
      this.time = time;
      // this.ended = false;
    },
    onTrackEnd(e) {
      console.log('onTrackEnd', e);
      // this.ended = true;
    },
    // onTrackPost(e) {
    //   console.log('onTrackPost', e);
    // },
    nextScene(e) {
      console.log('Scene.nextScene', this.id, e);
      this.$refs.player.stop();
      this.$router.push(this.nextPath)
    },
  },
  computed: {
    showNext() {
      let retval = false;
      let duration = 1000;
      if (this.$refs.player) {
        duration = this.$refs.player.duration;
      }
      
      if (this.trackPostTime && this.trackPostTime != 0) {
        let trackPostTime = this.trackPostTime;
        if (this.trackPostTime < 0) {
          trackPostTime = duration + trackPostTime;
        }

        if (this.time <= trackPostTime) {
          retval = false;
        } else if (this.time > trackPostTime) {
          retval = true;
        }        
      } else {
        retval = this.time+1 >= duration;
      }
      return retval;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .fullscreen {
  overflow: scroll;
}
.center-control {
  position:fixed;
  top: 20vh;
  width: 100%;
  text-align: center;
} */
.middle-control {
  top: 9rem;
}


button.nextbtn {
  height: 42vh;
  width: 30vh;
  font-weight: bold;
  font-size: large;
}

</style>
